import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export interface ClaimState {
  id: string;
  first_name: string;
  name: string;
  last_name: string;
  email: string;
  phone_number: string;
  address_1: string;
  address_2: string;
  city: string;
  state: string;
  zip: string;
  allowSMS: boolean;
  // Step 2 fields
  store_of_purchase: string;
  retailer_phone: string;
  retailer_address_1: string;
  retailer_address_2: string;
  retailer_city: string;
  retailer_state: string;
  retailer_zip: string;
  purchase_date: string;
  invoice_image: string;
  // Step 3 fields
  date_of_incident: string;
  product_size: string;
  product_type: string;
  mattress_stained_damaged: boolean;
  type_of_stain_damage: string;
  protector_encasement_stained_damaged: boolean;
  type_of_stain_damage_protector: string;
  estimated_mattress_retail_value: number;
  did_you_clean_the_protector_encasement: boolean;
  encasement_on_your_bed_at_the_time_of_the_incident: boolean;
  damageNotes: string;
  protector_damage_images: string[];
  mattress_damage_images: string[];
  protectall_tag_image: string;
}

export enum ClaimAction {
  UPSERT_CLAIM = "UPSERT_CLAIM",
  REMOVE_CLAIM_IMAGE = "REMOVE_CLAIM_IMAGE",
  UPLOAD_CLAIM_IMAGE = "UPLOAD_CLAIM_IMAGE",
  SUBMIT_CLAIM = "SUBMIT_CLAIM",
  UPDTAE_CLAIM_STATE = "UPDTAE_CLAIM_STATE",
  FETCH_CLAIM_INFO = "FETCH_CLAIM_INFO",
  CLEAN_UP = "CLEAN_UP",
}

export type ClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const ClaimScope = "claim";
